import * as THREE from 'three';
import { MECHS } from '../entities/mechs';
import { P } from '../world/player';
/* ============================================================
   圖鑑的「你」：玩家的參照值
   ============================================================

   右欄的數值條要回答的是「這隻對**我**來說怎麼樣」，所以需要一組玩家的值。

   ⚠️ **實測出來的事實：玩家的值不在敵人的量尺上。**

     玩家 CHASSIS-0 速度 11.5，小怪數值條的上限是 4.0（最快的 NADEL 3.1）
     玩家 主武裝射程 30，小怪數值條的上限是 9.0（最遠的 8.5）

   差三倍到三倍半。所以「在條上畫一道『你』的刻度」畫不出來 —— 那道線會在
   每一條的框外。硬把上限拉到 30 的話，四十隻小怪會全部擠在最左邊的一成，
   彼此的差異反而消失（「相對於這批資料的極值」那條老規矩）。

   **所以分成兩件事講**：
   - 條上畫的是**全體中位數**（永遠在範圍內，給的是「這隻在同類裡算哪一端」）
   - 值的後面附一句**相對你的百分比**（給的是「這隻對我來說快不快」）

   兩者都給，才不會為了版面整齊而說謊。 */

/** 高度是**量出來的**，不是抄常數的 —— rig 改過好幾版
    （`entities/mechs.ts` 明講 `waistY` 已經拿掉），抄下來遲早會跟造型對不上。
    量的是**目前裝備中的那台**：兩台機體差 17%（4.46 vs 3.71），拿別台的
    高度去算「這隻比你高幾成」是直接說謊。快取以機體 id 為 key。 */
var ph: any = {};
function playerHeight(mech) {
  var id = mech.id;
  if (ph[id]) return ph[id];
  var h = 0;
  try {
    var rig = (P && P.rig && P.mech && P.mech.id === id) ? P.rig : mech.build();
    rig.root.updateMatrixWorld(true);
    var b = new THREE.Box3().setFromObject(rig.root);
    h = Math.max(1, b.max.y - Math.min(0, b.min.y));
  } catch (e) {
    // headless：沒有 WebGL 也要有一個數字（實測值，見 tools/mech-shot2.mjs）
    h = id === 'lancer2' ? 3.71 : id === 'titan3' ? 3.61 : 4.46;
  }
  ph[id] = h;
  return h;
}

/** 玩家的參照值。**全部是世界單位**：`spd` 是世界單位／秒、`rng` 是世界單位、
    `h` 是量出來的實際高度（公尺）。

    ⚠️ 舊版把 `h` 除回「敵人欄位那把尺」，好讓它跟 `T.h` 直接相除 ——
    但敵人那一側的倍率不是常數（大型 BOSS 走 `bossFieldScale` 壓縮），
    所以那個相除會說謊：KAISER 曾經因此顯示「你的 1090%」而畫面上是 3.6 倍。
    現在兩邊都換算成世界單位再比（`ui/codex-bars.ts` 的 `vsYou`）。 */
export function playerRef() {
  /* **用玩家實際選的那台**，不是寫死 CHASSIS-0。LANCER-2 的射程是 7.6
     而不是 30（差四倍），寫死的話近戰玩家看到的每一句「相對你」都是錯的。
     還沒開局（標題頁翻圖鑑）時退回預設機體。 */
  var M: any = (P && P.mech) || MECHS.chassis0;
  return {
    spd: M.speed,
    rng: M.stats.atkRange,
    h: playerHeight(M),
    /* 預備時間沒有玩家對應值 —— 玩家的攻擊沒有「預備」這個概念。
       這一欄只能跟全體比，不要硬湊一個數字出來。 */
    tTel: 0
  };
}
